// Packages
import Vue from 'vue';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/price.scss';

// Components
import '~scripts/components/modals';

//
// HEADER
//
import Header from '~scripts/blocks/header';

Header();

//
// NAVIGATION
//
import Navigation from '~scripts/blocks/navigation';

Navigation();

//
// MAIN
//
// Blocks
import ClientsLogotypes from '~scripts/blocks/vue/ClientsLogotypes.vue';

// Components
import Tabs from '~scripts/components/vue/Tabs.vue';

// Pricing
import Price from './vue/Price/Price.vue';
import PricingTariffs from './vue/PricingTariffs/PricingTariffs.vue';
import PricingTariffsFeatures from './vue/PricingTariffsFeatures/PricingTariffsFeatures.vue';
import PricingAll from './vue/PricingAll/PricingAll.vue';
import PricingTable from './vue/PricingTable/PricingTable.vue';
import PricingFaq from './vue/PricingFaq/PricingFaq.vue';

// Init
new Vue({
  el: '#VPrice',
  name: 'VPrice',
  components: {
    ClientsLogotypes,
    PricingTariffs,
    PricingTariffsFeatures,
    PricingAll,
    PricingTable,
    PricingFaq,
    Price,
    Tabs,
  },
  data: {
    currency: 'rub',
  },
  methods: {
    handleTabCurrency(current) {
      this.currency = current === 0 ? 'rub' : current === 1 ? 'usd' : 'eur';

      this.$root.$emit('scrollToTop'); // called in `PricingTariffsSlider.vue`
    },
  },
});

//
// REQUEST FORM
//
import initRequestForm from '~scripts/blocks/request-form';

const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});
